module.exports = __webpack_public_path__ + "static/valentin-radulescu-resume.4019ef34.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentin-radulescu-resume.pdf
// module id = 105
// module chunks = 35783957827783 156897593687669